export const APP_NAME = '@GenesisHotels';
export const WEB_AUTH_TOKEN = 'GEN-HOTEL-TOKEN'
